import React from 'react';
import PropTypes from 'prop-types';
import RecommendedTargetAmountChart from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';

const EmergencyFundGoalChartView = props => {
  const { goalId, initialChartData, clientId, fpId, responseData, isCurrentPlan, title } = props;
  return (
    <>
      <h4>{title}</h4>
      <RecommendedTargetAmountChart
        noContainer
        isCurrentPlan={isCurrentPlan}
        goalId={goalId}
        data={initialChartData ? { GoalCharts: [initialChartData] } : null}
        clientId={clientId}
        fpId={fpId}
        responseData={responseData}
      />
    </>
  );
};

EmergencyFundGoalChartView.defaultProps = {
  initialChartData: null,
  responseData: null,
};

EmergencyFundGoalChartView.propTypes = {
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  initialChartData: PropTypes.shape({}),
  goalId: PropTypes.string.isRequired,
  responseData: PropTypes.shape({}),
  isCurrentPlan: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default EmergencyFundGoalChartView;
